"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _messageTemplate = require('shared/actions/messageTemplate'); var _messageTemplate2 = _interopRequireDefault(_messageTemplate);
var _typed = require('shared/hooks/typed');

var _common = require('shared/selectors/blobject/common/common');
var _messageTemplate3 = require('shared/selectors/messageTemplate');
var _myRelations = require('shared/selectors/myRelations');
var _team = require('shared/selectors/team');
var _user = require('shared/selectors/user');
var _templateComposer = require('shared/services/templateComposer');

var _templateResolver = require('shared/services/templateResolver');
var _useChatTemplateContext = require('./useChatTemplateContext');



/* Loads the org's templates each time the picker mounts (teammates' edits
 * show up then; no live push) and turns them into picker rows for this chat,
 * with the values the chat fills in. The picker offers the templates
 * usableTemplates allows: mine, the org's, my teams', and for an org admin
 * the chat's teams' too. */
 const useTemplatePickerRows = (orgKey, blobjectKey, query) => {
  const allTemplates = _typed.useAppSelector.call(void 0, state => _messageTemplate3.selectMessageTemplates.call(void 0, state, orgKey))
  const myTeamKeys = _typed.useAppSelector.call(void 0, _myRelations.selectMyTeamKeys)
  const isAdmin = _typed.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const chatTeams = _typed.useAppSelector.call(void 0, state => _optionalChain([_common.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.TeamSubscribers]))
  const templates = _react.useMemo.call(void 0, 
    () => _templateComposer.usableTemplates.call(void 0, allTemplates, myTeamKeys, isAdmin, Object.keys(_nullishCoalesce(chatTeams, () => ( {})))),
    [allTemplates, isAdmin, chatTeams, myTeamKeys],
  )
  const context = _useChatTemplateContext.useChatTemplateContext.call(void 0, orgKey, blobjectKey)
  const teams = _typed.useAppSelector.call(void 0, _team.selectTeams)
  const [status, setStatus] = _react.useState('loading')

  _react.useEffect.call(void 0, () => {
    let live = true
    _messageTemplate2.default.listMessageTemplates(orgKey)
      .then(() => live && setStatus('ready'))
      .catch(() => live && setStatus('error'))
    return () => { live = false }
  }, [orgKey])

  const teamNames = _react.useMemo.call(void 0, 
    () => Object.fromEntries(Object.values(_nullishCoalesce(teams, () => ( {}))).map(t => [t.TeamKey, t.Name])),
    [teams],
  )
  // What a template is filled with here; in a chat with several patients,
  // fillFor gives it for the one the sender picks.
  const fill = _react.useMemo.call(void 0, () => ({ values: _templateResolver.templateValues.call(void 0, context), defaults: _templateResolver.templateDefaults.call(void 0, context) }), [context])
  const fillFor = _react.useCallback.call(void 0, 
    (patientKey) => ({ values: _templateResolver.templateValues.call(void 0, context, patientKey), defaults: _templateResolver.templateDefaults.call(void 0, context, patientKey) }),
    [context],
  )
  const rows = _react.useMemo.call(void 0, () => _templateComposer.pickerRows.call(void 0, templates, query, fill.values, teamNames, fill.defaults), [templates, query, fill, teamNames])
  // Rows already loaded show while the list refreshes.
  return { rows, fill, fillFor, context, status: status === 'loading' && templates.length > 0 ? 'ready' : status }
}; exports.useTemplatePickerRows = useTemplatePickerRows
